import React, { useState } from 'react';
import { Alert } from '../../types/ltss';
import { AlertItem } from './AlertItem';

interface AlertListProps {
  alerts: Alert[];
  onSearchPerson?: (name: string, type: 'staff' | 'client') => void;
}

export function AlertList({ alerts, onSearchPerson }: AlertListProps) {
  const [expandedId, setExpandedId] = useState<string | null>(null);

  if (alerts.length === 0) {
    return (
      <div className="card p-8 text-center">
        <p className="text-slate-400">No alerts to display</p>
      </div>
    );
  }

  return (
    <div className="card overflow-hidden">
      <div className="max-h-[500px] overflow-y-auto divide-y divide-slate-700">
        {alerts.map((alert) => (
          <AlertItem
            key={alert.id}
            alert={alert}
            isExpanded={expandedId === alert.id}
            onToggle={() => setExpandedId(expandedId === alert.id ? null : alert.id)}
            onSearchPerson={onSearchPerson}
          />
        ))}
      </div>
    </div>
  );
}
